(function(){
  var MONEY_FMT = window.Shopify && window.Shopify.money_format || '${{amount}}';

  function fmt(cents) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    if (isNaN(cents)) return '$0.00';
    var n = (cents / 100).toFixed(2);
    var pts = n.split('.');
    var whole = pts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return MONEY_FMT.replace(/\{\{\s*amount\s*\}\}/, whole + '.' + pts[1])
                     .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
                     .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, pts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',' + pts[1]);
  }

  function getCurrentVariantIdFromContext() {
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) return parseInt(m[1], 10);
    var mainForm = document.querySelector('.yv-main-product-detail form[action*="/cart/add"], .main-product-section form[action*="/cart/add"]');
    if (mainForm) {
      var input = mainForm.querySelector('[name="id"]');
      if (input && input.value) return parseInt(input.value, 10);
    }
    return null;
  }

  document.querySelectorAll('.section-fbt').forEach(function(section) {
    if (section.dataset.fbtInit === '1') return;
    section.dataset.fbtInit = '1';
    var items = section.querySelectorAll('.fbt-item[data-toggleable]');
    var totalEl = section.querySelector('[data-fbt-total]');
    var strikeEl = section.querySelector('[data-fbt-strike]');
    var saveEl = section.querySelector('[data-fbt-save]');
    var saveAmt = section.querySelector('[data-fbt-save-amt]');
    var ctaBtn = section.querySelector('[data-fbt-cta]');
    var stickyTotalEl = section.querySelector('[data-fbt-sticky-total]');
    var stickyEl = section.querySelector('[data-fbt-sticky]');
    var stickyCta = section.querySelector('[data-fbt-sticky-cta]');
    if (!ctaBtn) return;
    var ctaBundle = ctaBtn.dataset.textBundle || 'Add Bundle to Cart';
    var ctaSingle = ctaBtn.dataset.textSingle || 'Add to Cart';

    var anchor = section.querySelector('.fbt-anchor');
    var anchorVariants = [];
    if (anchor && anchor.dataset.anchorVariants) {
      try { anchorVariants = JSON.parse(anchor.dataset.anchorVariants) || []; }
      catch(e) { anchorVariants = []; }
    }
    var anchorTagPrefix = (anchor && anchor.dataset.anchorTagPrefix) || 'This item';
    var anchorSoldOut = false;

    items.forEach(function(item) {
      item.addEventListener('click', function(e) {
        if (e.target.closest('[data-row-variant-select]')) return;
        toggle(item);
      });
      item.addEventListener('keydown', function(e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(item); }
      });
    });

    // Companion row variant pickers (multi-variant companion products)
    section.querySelectorAll('[data-row-variant-select]').forEach(function(sel){
      sel.addEventListener('change', function(){
        var row = sel.closest('.fbt-item');
        if (!row) return;
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        var available = opt.dataset.available === 'true';
        if (!available) {
          row.classList.add('fbt-soldout');
          row.classList.remove('fbt-checked');
          row.removeAttribute('data-toggleable');
          row.setAttribute('aria-checked', 'false');
        } else {
          row.classList.remove('fbt-soldout');
          row.setAttribute('data-toggleable', '');
        }
        row.dataset.variantId = opt.value;
        row.dataset.price = opt.dataset.price;
        row.dataset.comparePrice = opt.dataset.comparePrice;
        var priceEl = row.querySelector('[data-row-price]');
        var compareEl = row.querySelector('[data-row-compare]');
        if (priceEl) priceEl.textContent = fmt(parseInt(opt.dataset.price, 10));
        if (compareEl) {
          var c = parseInt(opt.dataset.comparePrice, 10) || 0;
          var p = parseInt(opt.dataset.price, 10) || 0;
          if (c > p) { compareEl.textContent = fmt(c); compareEl.style.display = ''; }
          else { compareEl.style.display = 'none'; }
        }
        var img = row.querySelector('[data-row-img]');
        if (img && opt.dataset.img) img.src = opt.dataset.img;
        recalc();
      });
    });

    // Sticky mobile bundle CTA
    if (stickyEl && stickyCta && 'IntersectionObserver' in window) {
      var card = section.querySelector('.fbt-card');
      if (card) {
        new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              stickyEl.classList.remove('is-visible');
              stickyEl.setAttribute('aria-hidden', 'true');
            } else if (entry.boundingClientRect.top < 0) {
              stickyEl.classList.add('is-visible');
              stickyEl.setAttribute('aria-hidden', 'false');
            }
          });
        }, { threshold: 0.05 }).observe(card);
      }
      stickyCta.addEventListener('click', function() { ctaBtn.click(); });
    }

    function toggle(item) {
      item.classList.toggle('fbt-checked');
      item.setAttribute('aria-checked', item.classList.contains('fbt-checked'));
      recalc();
    }

    // Sync anchor row data to a given variant ID — fired when main PDP variant picker changes
    function syncAnchorFromVariantId(vid) {
      if (!anchor || !anchorVariants.length) return;
      var v = null;
      for (var i = 0; i < anchorVariants.length; i++) {
        if (anchorVariants[i].id === vid) { v = anchorVariants[i]; break; }
      }
      if (!v) return;

      anchor.dataset.variantId = v.id;
      anchor.dataset.price = v.price;
      anchor.dataset.comparePrice = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;

      var pEl = anchor.querySelector('[data-fbt-price-val]');
      if (pEl) pEl.textContent = fmt(v.price);

      var cEl = anchor.querySelector('[data-fbt-compare-val]');
      if (cEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          cEl.textContent = fmt(v.compare_at_price);
          cEl.style.display = '';
        } else { cEl.style.display = 'none'; }
      }

      // Variant image
      if (v.featured_image && v.featured_image.src) {
        var img = anchor.querySelector('.fbt-img img');
        if (img) img.src = v.featured_image.src.replace(/(\.\w+)(\?|$)/, '_200x200$1$2');
      }

      // Variant title (e.g., "iPhone 16 Pro Max")
      var tagEl = anchor.querySelector('.fbt-tag');
      if (tagEl) {
        if (v.title && v.title !== 'Default Title') {
          tagEl.textContent = anchorTagPrefix + ' · ' + v.title;
        } else {
          tagEl.textContent = anchorTagPrefix;
        }
      }

      anchorSoldOut = !v.available;
      if (anchorSoldOut) anchor.classList.add('fbt-soldout');
      else anchor.classList.remove('fbt-soldout');

      recalc();
    }

    // Hook into main PDP variant picker — listen to the form's hidden [name="id"] input
    var mainForm = document.querySelector('.yv-main-product-detail form[action*="/cart/add"], .main-product-section form[action*="/cart/add"]');
    var variantInput = mainForm ? mainForm.querySelector('[name="id"]') : null;
    if (variantInput) {
      variantInput.addEventListener('change', function() {
        var vid = parseInt(variantInput.value, 10);
        if (vid) syncAnchorFromVariantId(vid);
      });
    }
    window.addEventListener('popstate', function handler() {
      // Self-teardown: theme editor replaces the section element on reload; drop stale listeners
      if (!document.body.contains(section)) { window.removeEventListener('popstate', handler); return; }
      var vid = getCurrentVariantIdFromContext();
      if (vid) syncAnchorFromVariantId(vid);
    });
    // Initial sync — in case URL ?variant= differs from server-rendered anchor variant
    setTimeout(function() {
      var vid = getCurrentVariantIdFromContext();
      if (vid && anchor && vid !== parseInt(anchor.dataset.variantId, 10)) {
        syncAnchorFromVariantId(vid);
      }
    }, 400);

    function recalc() {
      var checked = section.querySelectorAll('.fbt-item.fbt-checked');
      var total = 0, compare = 0;
      checked.forEach(function(r) {
        total += parseInt(r.dataset.price, 10) || 0;
        compare += parseInt(r.dataset.comparePrice || r.dataset.price, 10) || 0;
      });
      var savings = compare - total;
      if (totalEl) totalEl.textContent = fmt(total);
      if (stickyTotalEl) stickyTotalEl.textContent = fmt(total);
      if (strikeEl) {
        strikeEl.textContent = fmt(compare);
        strikeEl.style.display = savings > 0 ? '' : 'none';
      }
      if (saveEl) {
        saveEl.style.display = savings > 0 ? '' : 'none';
        if (saveAmt) saveAmt.textContent = fmt(savings);
      }
      var companions = section.querySelectorAll('.fbt-item.fbt-checked:not(.fbt-anchor)').length;
      if (anchorSoldOut) {
        ctaBtn.disabled = true;
        ctaBtn.classList.add('fbt-soldout');
        ctaBtn.textContent = 'Sold Out';
        if (stickyCta) { stickyCta.disabled = true; stickyCta.textContent = 'Sold Out'; }
      } else {
        ctaBtn.disabled = total === 0;
        ctaBtn.classList.remove('fbt-soldout');
        ctaBtn.textContent = companions > 0 ? ctaBundle : ctaSingle;
        if (stickyCta) { stickyCta.disabled = total === 0; stickyCta.textContent = companions > 0 ? ctaBundle : ctaSingle; }
      }
    }

    ctaBtn.addEventListener('click', function() {
      if (ctaBtn.disabled || anchorSoldOut) return;
      var checked = section.querySelectorAll('.fbt-item.fbt-checked');
      if (!checked.length) return;
      ctaBtn.disabled = true;
      ctaBtn.textContent = 'Adding…';

      // Fetch current cart to dedupe anchor (don't re-add if user already added via main ATC)
      fetch('/cart.js', { headers: {'Accept':'application/json'} })
        .then(function(r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); })
        .then(function(cart) {
          var inCart = {};
          (cart.items || []).forEach(function(i) { inCart[i.variant_id] = true; });
          var payload = [];
          checked.forEach(function(r) {
            var vid = parseInt(r.dataset.variantId, 10);
            if (!vid) return;
            // Skip anchor if already in cart with this variant — prevents double-add
            if (r.classList.contains('fbt-anchor') && inCart[vid]) return;
            payload.push({ id: vid, quantity: 1 });
          });

          if (!payload.length) {
            // Everything already in cart — just open drawer
            ctaBtn.textContent = '✓ In Cart';
            ctaBtn.classList.add('fbt-success');
            var cartIcon = document.querySelector('.openCartDrawer');
            if (cartIcon) cartIcon.click();
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(function() { ctaBtn.disabled = false; ctaBtn.classList.remove('fbt-success'); recalc(); }, 2000);
            return;
          }

          return fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: payload })
          })
          .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function() {
            ctaBtn.textContent = '✓ Added to Cart';
            ctaBtn.classList.add('fbt-success');
            var cartIcon = document.querySelector('.openCartDrawer');
            if (cartIcon) cartIcon.click();
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(function() { ctaBtn.disabled = false; ctaBtn.classList.remove('fbt-success'); recalc(); }, 2000);
          });
        })
        .catch(function() {
          ctaBtn.textContent = 'Error — Try Again';
          ctaBtn.classList.add('fbt-error');
          setTimeout(function() { ctaBtn.disabled = false; ctaBtn.classList.remove('fbt-error'); recalc(); }, 2000);
        });
    });

    // Initial: check anchor availability from the render-time variant
    if (anchor && anchorVariants.length) {
      var initialVid = parseInt(anchor.dataset.variantId, 10);
      for (var k = 0; k < anchorVariants.length; k++) {
        if (anchorVariants[k].id === initialVid) {
          anchorSoldOut = !anchorVariants[k].available;
          if (anchorSoldOut) anchor.classList.add('fbt-soldout');
          break;
        }
      }
    }
    recalc();
  });
})();
